<template>
    <section class="key_vacancies position-relative">

        <v-tabs
                v-model="tab"
                @change="changeTab"
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                show-arrows
        >
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in items" :key="item.label">
        <span class="key_vacancies__tab">
          {{ item.label }}
        </span>
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item v-for="tabItem in items" :key="tabItem.label">
                <v-card flat>
                    <div class="key_vacancies__grid">
                        <div
                                class="key_vacancies__item position-relative d-flex flex-column"
                                v-for="el in tabItem.item"
                                :key="el.label + el.address"
                        >
                            <a :href="el.url" class="position-absolute w-100 h-100 t-0 l-0 zi-1"></a>
                            <div class="flex-grow-1">{{ el.label }}</div>
                            <div>{{ el.address }}</div>
                            <div class="d-flex align-items-center  key_vacancies__item_info">
                                <div class="mr-4" v-if="el.experience">
                                    <strong>Опыт:</strong> {{el.experience}}
                                </div>
                                <div v-if="el.employment">
                                    <strong>Занятость:</strong> {{ el.employment }}
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </section>
</template>

<script>
export default {
    name: "keyVacancies",
    props: {
        elements: Array | Object | String,
    },
    data() {
        return {
            tab: 0, // по умолчанию первый таб

            /*items: [
              {
                label: "Все",
                item: [
                  {
                    experience: 'от 1 до 3 лет',
                    employment: 'Полная',
                    url: '/career/vacancy/detail.php',
                    address: 'Нижегородская обл. г.Дзержинск\n',
                    label: 'Мастер отдела главного энергетика'
                  },
                  {
                    experience: 'от 1 до 5 лет',
                    employment: 'Полная',
                    url: '/career/vacancy/detail.php',
                    address: 'Нижегородская обл. г.Дзержинск\n',
                    label: 'Мастер отдела главного энергетика'
                  },
                  {
                    experience: 'от 1 до 2 лет',
                    employment: 'Полная',
                    url: '/career/vacancy/detail.php',
                    address: 'Нижегородская обл. г.Дзержинск\n' +
                        'Восточное шоссе 88А',
                    label: 'Мастер отдела главного энергетика'
                  },
                ],
              },
              {
                label: "Производство",
                item: [
                  {
                    experience: 'от 1 до 4 лет',
                    employment: 'Полная',
                    url: '/career/vacancy/detail.php',
                    address: 'Нижегородская обл. г.Дзержинск\n' +
                        'Восточное шоссе 88А',
                    label: 'Мастер отдела главного энергетика'
                  },
                  {
                    experience: 'от 1 до 2 лет',
                    employment: 'Полная',
                    url: '/career/vacancy/detail.php',
                    address: 'Нижегородская обл. г.Дзержинск\n' +
                        'Восточное шоссе 88А',
                    label: 'Мастер отдела главного энергетика'
                  },
                ],
              },
              {
                label: "Офис",
                item: [
                  {
                    experience: 'от 1 до 2 лет',
                    employment: 'Полная',
                    url: '/career/vacancy/detail.php',
                    address: 'Нижегородская обл. г.Дзержинск\n' +
                        'Восточное шоссе 88А',
                    label: 'Мастер отдела главного энергетика'
                  },
                  {
                    experience: 'от 1 до 2 лет',
                    employment: 'Полная',
                    url: '/career/vacancy/detail.php',
                    address: 'Нижегородская обл. г.Дзержинск\n' +
                        'Восточное шоссе 88А',
                    label: 'Мастер отдела главного энергетика'
                  },
                ],
              },
              {
                label: "Руководящие позиции",
                item: [
                  {
                    experience: 'от 1 до 2 лет',
                    employment: 'Полная',
                    url: '/career/vacancy/detail.php',
                    address: 'Нижегородская обл. г.Дзержинск\n' +
                        'Восточное шоссе 88А',
                    label: 'Мастер отдела главного энергетика'
                  },
                  {
                    experience: 'от 1 до 2 лет',
                    employment: 'Полная',
                    url: '/career/vacancy/detail.php',
                    address: 'Нижегородская обл. г.Дзержинск\n' +
                        'Восточное шоссе 88А',
                    label: 'Мастер отдела главного энергетика'
                  },
                ],
              },

            ],*/
            items: this.elements,
        }
    },

    mounted() {
        this.initTabFromHash()
        window.addEventListener('hashchange', this.onHashChange)
    },

    beforeDestroy() {
        window.removeEventListener('hashchange', this.onHashChange)
    },

    methods: {
        // читаем хеш и активируем нужный таб
        initTabFromHash() {
            const rawHash = window.location.hash || ''
            const hash = rawHash ? decodeURIComponent(rawHash.substring(1)) : ''

            if (!hash) {
                this.tab = 0
                return
            }

            const index = this.items.findIndex(item => item.label === hash)
            this.tab = index !== -1 ? index : 0
        },

        onHashChange() {
            this.initTabFromHash()
        },

        // вызывается при переключении таба
        changeTab(newIndex) {
            console.log("changeTab", newIndex);
            const item = this.items[newIndex]
            if (!item) return

            const newHash = encodeURIComponent(item.label)
            const newUrl = `${window.location.pathname}#${newHash}`

            if (window.location.hash !== `#${newHash}`) {
                history.replaceState(null, '', newUrl)
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.key_vacancies {
  margin-bottom: 80px;

  &__grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 8px;
    margin-top: 30px;

    @media (max-width: 1200px) {
      grid-template-columns: 1fr 1fr;
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  &__item {
    height: 240px;
    gap: 16px;
    border-radius: 32px;
    padding: 32px;
    border: 1px solid #E8E8E8;
    //box-shadow: 0px 4px 30px 0px #0000000D;
    -webkit-transition: all ease-in-out .2s;
    -o-transition: all ease-in-out .2s;
    transition: all ease-in-out .2s;
    font-family: "MuseoSansCyrl-500";
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: -0.26px;
    vertical-align: middle;

    @media (max-width: 768px) {
      height: auto;
    }

    &:hover,
    &:focus {
      background: #fafafa;
    }
  }

  &__item_info {
    gap: 28px;
  }


  &__select {
    margin: 32px 0;
  }

  &__content {
    border-radius: 40px !important;
    background: #F5F5F7;
  }


  &__info {
    position: absolute;
    top: 5px;
    right: 5px;
    display: flex;
    flex-direction: column;
    align-items: start;
    height: 100%;
    margin-top: 0 !important;

    @media (max-width: 900px) {
      position: unset;
    }
  }


  &__img {
    border-radius: 40px;
    max-width: 1840px;
    width: 100%;
    height: 100%;
    max-height: 790px;
    object-fit: cover;
  }

  &__dots {
    position: relative;
  }

  &__dot {
    position: absolute;
    background: #f94237;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;

    &:before {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #FFFFFF;
      width: 0.8rem;
      height: 0.8rem;;
      border-radius: 50%;
    }

    &:after {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #f94237;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
    }
  }


}

</style>

<style lang="scss">

.key_vacancies {

  .v-card .v-card--flat .v-sheet .theme--light {
    border-radius: 40px !important;
  }

  .v-tab:not(.v-tab--active) {
    & svg {
      display: none;
    }
  }

  & .v-tabs-slider {
    height: 0;
  }

  .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none;
  }

  .v-tabs {
    @media (max-width: 766px) {
      max-width: 90vw;
    }
  }

  & .v-tab {
    gap: 14px;
    margin: 5px;
    border: 1.4px solid #E8E8E8;
    background: #FFFFFF;
    border-radius: 40px;
    padding: 16px 20px;
    height: 52px;
    transition: all 0.2s ease;

    @media (max-width: 1024px) {
      padding: 5px 60px;
    }

    @media (max-width: 1024px) {
      padding: 5px 20px;
    }

    &:hover {
      opacity: 1 !important;
      border-color: #4F4D55;
    }

    &:before {
      background-color: transparent !important;
    }

    & > span {
      font-family: 'MuseoSansCyrl-500';
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0;
      color: #4F4D55 !important;
      text-transform: none;
    }

    &--active {
      border: 1.5px solid #F94337;
      border-radius: 40px;
      mask-image: radial-gradient(white, black);
      will-change: transform;

      &:hover {
        opacity: 1 !important;
        border-color: #F94337;
      }

      &:before {
        background-color: transparent !important;
      }

      & > span {
        color: #F94337 !important;
      }
    }

  }

  & .v-tabs-bar {
    height: unset;
  }

  & .v-tabs-bar,
  & .theme--light.v-tabs-items {
    background-color: transparent !important;
  }

  .mdi-arrow-right-bold-box-outline::before {
    position: absolute;
    top: -10px;
    content: '';
    background: url("/local/templates/international/img/fi_chevron-down.svg") no-repeat;
    background-size: contain;
    width: 25px;
    height: 25px;
  }

  .mdi-arrow-left-bold-box-outline::before {
    position: absolute;
    top: -10px;
    content: '';
    background: url("/local/templates/international/img/fi_chevron-down.svg") no-repeat;
    background-size: contain;
    width: 25px;
    height: 25px;
    rotate: 180deg;
  }

  & .v-ripple__container {
    display: none;
  }

  .v-slide-group__next, .v-slide-group__prev {
    min-width: 33px;
  }

  .v-slide-group__wrapper {
    height: 60px;
  }

  .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
  }

  &__content {

    & .v-slide-group__content {
      display: block;
      flex: unset;
      width: 100%;
    }

    & .v-slide-group__wrapper {
      height: 100% !important;
    }

    & .theme--light.v-tabs > .v-tabs-bar {
      margin-bottom: 40px;
      height: 100%;
    }

    & .v-tabs {
      position: absolute;
      top: 0;
      height: 100%;
    }

    & .v-tab {
      min-width: unset !important;
      width: 2rem !important;
      height: 2rem !important;
      border-radius: 50% !important;
      padding: 0 !important;

      &--active {
        box-shadow: 0 0 0 0.5rem rgba(251, 66, 55, 0.5) !important;
        border: none;
        mask-image: none;

        &:before {
          display: none;
          background-color: transparent !important;
          width: 32px !important;
          height: 32px !important;
          border-radius: 50% !important;
        }
      }
    }

  }


}


</style>